/*
 * © 2017 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
import { getType } from "typesafe-actions";
import {
  getStaticData,
  liveRefreshWatcher,
  calculateJobPerformanceOnMetadataChange,
} from "./sagas";
import { rootActions } from "../";
import {
  all,
  race,
  takeEvery,
  takeLatest,
  take,
  call,
  fork,
  cancel,
  select,
} from "typed-redux-saga";
import {
  fetchFilesDetailsForFileInfoIds,
  downloadFileForSelectedFileId,
  refreshJobSummaryFilesOnPopupOpened,
} from "../global/sagas";

export function* jobPerformanceRootSaga() {
  yield* fork(jobPerfRefreshLoopSaga);
  yield* fork(watchActiveSettingChangeCalculateJobPerfMetatadata);
  // Initial work
  yield* all([
    yield* race({
      jobSummaryPopupFilesTabClickedWatcher: takeLatest(
        getType(rootActions.global.jobSummaryPopupFilesTabClicked),
        fetchFilesDetailsForFileInfoIds
      ),
      downloadFileWatcher: takeEvery(
        getType(rootActions.global.jobSummaryPopupDownloadFileButtonClicked),
        downloadFileForSelectedFileId
      ),
      jobSummaryPopupOpenedWatcher: takeEvery(
        getType(rootActions.global.popupUpdated),
        refreshJobSummaryFilesOnPopupOpened
      ),
      cancel: take(getType(rootActions.session.startEndUpdated)),
    }),

    yield* takeLatest(
      getType(rootActions.global.jobSummaryPopupFilesTabClicked),
      fetchFilesDetailsForFileInfoIds
    ),
    yield* takeEvery(
      getType(rootActions.global.jobSummaryPopupDownloadFileButtonClicked),
      downloadFileForSelectedFileId
    ),
    yield* takeEvery(
      getType(rootActions.global.popupUpdated),
      refreshJobSummaryFilesOnPopupOpened
    ),
  ]);
}

function* jobPerfRefreshLoopSaga() {
  while (true) {
    yield* call(getStaticData);
    yield* race({
      liveRefreshWatcher: call(liveRefreshWatcher),
      cancel: take([getType(rootActions.session.startEndUpdated)]),
    });
  }
}

function* watchActiveSettingChangeCalculateJobPerfMetatadata() {
  const tasks = [];
  while (true) {
    const action = yield* take(
      getType(rootActions.jobPerformance.setActiveFilterSettings)
    );
    const shouldRun = yield* select(
      (state) => state.jobPerformance.filter.userChangedGroupByOnPopup
    );
    if (shouldRun) {
      const task = yield* fork(calculateJobPerformanceOnMetadataChange, action);
      tasks.push(task);
    } else {
      for (const task of tasks) {
        yield cancel(task);
      }
      tasks.length = 0;
    }
  }
}
